import { PagingResultsViewModel } from '../../../core/_infrastructure/types/common';
import { TMedioTransporteViewModel, TcSubTipoSolicitudViewModel } from '../datosbasicos/datosbasicos.types';
import { TProductoSolicitudViewModel } from '../productos/productos.types';

//La navegación es: TMedioTransporte --> TSolicitud y TPredua --> TPartidaPredua

export class TMedioTransportePreDuaViewModel {
    public IdSolicitud: number;
    public IdMedioTransporte: number | null = null;
    public NumeroOMI = '';
    public FechaLlegada: Date | null = null;
    public NumeroDeclaracionSumaria = '';
    public Mrn = '';
    public FechaRecuperacionMrn: Date | null = null;
    public IdPaisMedioTransporte: number | null = null;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;

    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;

    public TSolicitud: SolicitudPreduaViewModel;
    public TPredua: TPreduaViewModel;
}

export class SolicitudPreduaViewModel {
    public Id: number;
    public IdEstadoSolicitud = 0;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPredua: boolean;
    public EsReImportacion: boolean;
}

export class TPreduaViewModel {
    public Mrn = '';
    public IdOperacion: number;
    public FechaPresentacion: Date;
    public NombreExportador = '';
    public IdPaisExportador: number | null = null;
    public PaisExportador = '';
    public CiudadExportador = '';
    public DireccionExportador = '';
    public IdPif: number;
    public IdPifDescripcion: string;
    public IdAduanaDespacho: number;
    public IdAduanaDespachoDescripcion: string;
    public IdentificadorImportador = '';
    public RazonSocialImportador = '';
    public DireccionImportador = '';
    public IdPaisDestino: number | null = null;
    public PaisDestino = '';
    public IdPaisOrigen: number;
    public PaisOrigen = '';
    public IdMedioTransporte: number | null = null;
    public MedioTransporte = '';
    public FechaCreacion: Date;
    public FechaModificacion: Date;
    public FechaImportacion: Date;
    public IdBandejaEntrada: number | null = null;
    public IsPifCanarias: boolean;
    public TMedioTransporte: TMedioTransporteViewModel;
    public TPartidasPreduaList: TPartidaPreduaViewModel[];
    public TPosicionamientoPreduaList: TPosicionamientoPreduaViewModel[];
}

export class PartidaPreduaItemResultViewModel extends PagingResultsViewModel {
    public ResultList: TPartidaPreduaViewModel[];
}

export class TPartidaPreduaViewModel {
    public Id: number;
    public Partida = '';
    public CodigoTaric = '';
    public PaisOrigen = '';
    public IdPaisOrigen: number;
    public PesoNeto: number | null = null;

    public MatriculasList: TPartidaPreduaEquipamientoViewModel[];

    //campos para el grid
    public Acumulado: number;
    public strMatriculas = '';

    public SolicitudPartidasPreduaList: TProductoSolicitudViewModel[];
}

export class TPartidaPreduaEquipamientoViewModel {
    //public Id: number;
    //public IdPartidaPredua: number;
    public Matricula = '';
}

export class TPosicionamientoPreduaViewModel {
    public Matricula = '';
    public FechaAutorizacion: Date;
}
